import { render, staticRenderFns } from "./statementTable.vue?vue&type=template&id=21683804&scoped=true&"
import script from "./statementTable.vue?vue&type=script&lang=js&"
export * from "./statementTable.vue?vue&type=script&lang=js&"
import style0 from "./statementTable.vue?vue&type=style&index=0&id=21683804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21683804",
  null
  
)

export default component.exports